import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Collapse, Box } from '@mui/material';
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { useNavigate, useLocation } from 'react-router-dom';
import UserMenu from '../UserMenu/UserMenu';  // Import UserMenu

const DrawerMenu = ({ navLinks, drawerOpen, toggleDrawer, loggedIn, logo,t,direction,onLogout }) => {
    const navigate = useNavigate();
    const location = useLocation(); // Get the current URL path
    const [expanded, setExpanded] = useState({});

    const handleExpand = (index) => {
        setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const handleLogoClick = () => {
        navigate('/');
    };
    const handleLogout = () => {
        if (onLogout) onLogout();
        navigate('/');
      };
    // Check if a link or sublink is active
    const isActiveLink = (linkHref) => location.pathname === linkHref;
 // Check if any sublink is active and propagate active state to the parent link
 const isServiceLinkActive = (sublinks) => {
    return sublinks.some((sublink) => isActiveLink(sublink.href));
  };
    return (
        <Drawer
            // anchor="right"
            open={drawerOpen}
            onClose={() => toggleDrawer(false)}
            sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': {
                    width: '280px',
                    backgroundColor: 'var(--secondary-color)',
                    color: 'var(--text-color)',
                    direction:direction==='rtl'?"rtl":"ltr",
                    left: direction === 'ltr' ? '0' : 'auto', // Align to the left for LTR
                    right: direction === 'rtl' ? '0' : 'auto', // Align to the right for RTL
                },
            }}
        >
            {/* Logo Section */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '16px',
                    borderBottom: '1px solid var(--border-color)',
                    cursor: "pointer"
                }}
                onClick={handleLogoClick}
            >
                <img
                    src={logo}
                     loading="lazy"
                    alt="Logo"
                    style={{
                        height: '50px',
                        width: 'auto',
                    }}
                />
            </Box>



            <List>
                {navLinks.map((link, index) => (
                    <React.Fragment key={index}>
                        <ListItem
                            button
                            onClick={() => link.sublinks ? handleExpand(index) : navigate(link.href)}
                            selected={isActiveLink(link.href)}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'var(--primary-color)',
                                    '& .MuiListItemText-primary': {
                                        color: 'var(--secondary-color)',
                                    },
                                    '& .MuiListItemIcon-root': {
                                        color: 'var(--secondary-color)',
                                    },
                                },
                                backgroundColor:isActiveLink(link.href) || (link.sublinks && isServiceLinkActive(link.sublinks)) ?'var(--primary-color)' : 'transparent',
                                '& .MuiListItemText-primary': {
                                    color: isActiveLink(link.href) || (link.sublinks && isServiceLinkActive(link.sublinks)) ? 'var(--secondary-color)' : 'inherit',
                                },
                                '& .MuiListItemIcon-root': {
                                    color: isActiveLink(link.href) || (link.sublinks && isServiceLinkActive(link.sublinks)) ? 'var(--secondary-color)' : 'inherit',
                                },
                            }}
                        >
                            <ListItemIcon>
                                {link.icon}
                            </ListItemIcon>
                            <ListItemText
                                primary={link.label}
                                sx={{
                                    textAlign: direction==='rtl'?'right':'left', 
                                }}
                            />
                            {link.sublinks && (
                                <ListItemIcon>
                                    {expanded[index] ? (
                                        <AiOutlineMinus style={{ fontSize: '20px' }} />
                                    ) : (
                                        <AiOutlinePlus style={{ fontSize: '20px' }} />
                                    )}
                                </ListItemIcon>
                            )}
                        </ListItem>
                        {link.sublinks && (
                            <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {link.sublinks.map((sublink, subIndex) => (
                                        <ListItem
                                            button
                                            key={subIndex}
                                            onClick={() =>{  window.scrollTo({ top: 0, behavior: 'smooth' });
                                            navigate(sublink.href);}}
                                            selected={isActiveLink(sublink.href)}
                                            sx={{
                                                pl: 4,
                                                '&:hover': {
                                                    backgroundColor: 'var(--primary-color)',
                                                    '& .MuiListItemText-primary': {
                                                        color: 'var(--secondary-color)',
                                                    },
                                                },
                                                backgroundColor: isActiveLink(sublink.href) ? 'var(--primary-color)' : 'transparent',
                                                '& .MuiListItemText-primary': {
                                                    color: isActiveLink(sublink.href) ? 'var(--secondary-color)' : 'inherit',
                                                },
                                            }}
                                        >
                                            <ListItemText
                                                primary={sublink.label}
                                                sx={{
                                                    textAlign: direction==='rtl'?'right':'left', 
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        )}
                    </React.Fragment>
                ))}
            </List>
            {/* User Menu (conditionally rendered) */}
            {/* {!loggedIn && ( */}
                <Box sx={{
                    padding: '16px',
                    borderTop: '1px solid var(--border-color)',
                    direction: 'ltr',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                   
                }}>
                    <UserMenu loggedIn={loggedIn} direction={direction} t={t}  onLogout={onLogout}/>
                </Box>
            {/* )} */}


        </Drawer>
    );
};

export default DrawerMenu;
